export class NotificationType {
  id?: number;
  name = "";
  isAssessment = false;
  row = 0;
}

export class NotificationTypeDDL {
  text = "";
  value = 0;
}

export class SendTypeDDL {
  text = "";
  value = 0;
}

export class AssessmentDto {
  patientId = "";
  assessmentType = 0;
  triggerType = 0;
  phoneNumber = "";
  clientId = 0;
  surveyId: number | null = null;
}

export class UserNotification {
  clientId = 0;
  participantId = 0;
  surveyId = 0;
}

export class SmsNotification {
  clientId = 0;
  phoneNumber = "";
  message = "";
}

export enum SendTypes {
  PHONE = 0,
  WATCH = 1
}